import Button from '../common/Button';

function HeroSection() {
  return (
    <section className="hero-section">
      <div className="container hero-grid">
        <div className="hero-copy">
          <p className="eyebrow">Simplifying Ecommerce</p>
          <h1>Building businesses across Tech & Education</h1>
          <p>
            Factor Street E-commerce Services Pvt. Ltd. builds practical digital systems,
            education platforms, technology products, and long-term business initiatives.
          </p>
          <div className="hero-actions">
            <Button to="/#projects">Explore Our Projects</Button>
            <Button to="/contact" variant="secondary">
              Contact Us
            </Button>
          </div>
        </div>

        <div className="hero-panel" aria-label="FactorStreet operating focus">
          <div>
            <strong>Technology products</strong>
            <p>SaaS, workflow systems, and practical development platforms.</p>
          </div>
          <div>
            <strong>Education initiatives</strong>
            <p>Structured learning products and student-focused resources.</p>
          </div>
          <div>
            <strong>Digital businesses</strong>
            <p>Long-term operating projects with measurable business utility.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
